import React, {useContext, useRef, useState} from "react";
import {
    TableContainer,
} from "@mui/material";
import TableScroll from "../../../../../components/global/table/TableScroll";
import TablePaginationComponent from "../../../../../components/global/table/TablePagination";
import {PageContext} from "../../../../../context/pages";
import {useLazyQuery} from "@apollo/client";
import {GET_DNS_ZONES} from "../../../../../actions/get";
import {useDebouncedEffect} from "../../../../../hooks/useDebouncedEffect";
import {useParams} from "react-router";
import TableDnsZones from "../dnsZones/TableDnsZones";

const DnsZones = () => {
    const table = useRef(null);
    const { filter, setFilter } = useContext(PageContext);
    const [sortActive, setSortActive] = useState('sortId');
    const [isDelegated, setIsDelegated] = useState('');
    const [zoneType, setZoneType] = useState('');


    const { id: partnerClientAccountId } = useParams();

    const [getFilter, { data, loading }] = useLazyQuery(GET_DNS_ZONES);
    const getVariables = () => {
        const proxy = {
            limit: filter.limit,
            page: filter.page + 1,
            deletedAt: null,
            partnerClientAccountId: Number(partnerClientAccountId),
            [sortActive]: filter?.sort?.[sortActive]?.toUpperCase() || 'DESC',
        };

        if (filter?.id) {
            proxy.id = Number(filter?.id);
        }

        if (filter?.zone) {
            proxy.zone = String(filter?.zone)
        }

        if (isDelegated) {
            proxy.delegated = isDelegated
        }

        !filter?.sort?.checked ? proxy.deletedAtEq = null : proxy.deletedAtNeq = null

        if(zoneType) {
            zoneType === 'primary' ? proxy.remoteIdNeq = null : proxy.remoteIdEq = null
        }

        return proxy;
    };

    useDebouncedEffect(
        () => {
            getFilter({ variables: getVariables() });
        },
        500,
        [filter, isDelegated, zoneType],
    );

    return (
        <>
            <div>
                <TableScroll tableRef={table}>
                    <TableContainer>
                        <TableDnsZones
                            data={data}
                            setFilter={setFilter}
                            filter={filter}
                            sortActive={sortActive}
                            setSortActive={setSortActive}
                            partnerClientAccountId={partnerClientAccountId}
                            isDelegated={isDelegated}
                            setIsDelegated={setIsDelegated}
                            zoneType={zoneType}
                            setZoneType={setZoneType}
                        />
                        <TablePaginationComponent
                            filter={filter}
                            setFilter={setFilter}
                            count={data && data?.dnsResources?.info?.totalCount}
                            getFilter={getFilter}
                            getVariables={getVariables()}
                            type={'FILTER_ACTIVE'}
                        />
                    </TableContainer>
                </TableScroll>
            </div>
        </>
    )
};
export default DnsZones;
